/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 11L9 13M9 6L9 8M9 16L9 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.4 3H5.6C5.0426 3 4.76389 3 4.5307 3.03693C3.24702 3.24025 2.24025 4.24702 2.03693 5.5307C2 5.76389 2 6.0426 2 6.6V8.82353C2 8.92099 2.07901 9 2.17647 9C3.73586 9 5 10.2641 5 11.8235V12.1765C5 13.7359 3.73586 15 2.17647 15C2.07901 15 2 15.079 2 15.1765V17.4C2 17.9574 2 18.2361 2.03693 18.4693C2.24025 19.753 3.24702 20.7598 4.5307 20.9631C4.76389 21 5.0426 21 5.6 21H18.4C18.9574 21 19.2361 21 19.4693 20.9631C20.753 20.7598 21.7598 19.753 21.9631 18.4693C22 18.2361 22 17.9574 22 17.4V15.1765C22 15.079 21.921 15 21.8235 15C20.2641 15 19 13.7359 19 12.1765V11.8235C19 10.2641 20.2641 9 21.8235 9C21.921 9 22 8.92099 22 8.82353V6.6C22 6.0426 22 5.76389 21.9631 5.5307C21.7598 4.24702 20.753 3.24025 19.4693 3.03693C19.2361 3 18.9574 3 18.4 3Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M18.4 3H5.6C5.0426 3 4.76389 3 4.5307 3.03693C3.24702 3.24025 2.24025 4.24702 2.03693 5.5307C2 5.76389 2 6.0426 2 6.6V8.82353C2 8.92099 2.07901 9 2.17647 9C3.73586 9 5 10.2641 5 11.8235V12.1765C5 13.7359 3.73586 15 2.17647 15C2.07901 15 2 15.079 2 15.1765V17.4C2 17.9574 2 18.2361 2.03693 18.4693C2.24025 19.753 3.24702 20.7598 4.5307 20.9631C4.76389 21 5.0426 21 5.6 21H18.4C18.9574 21 19.2361 21 19.4693 20.9631C20.753 20.7598 21.7598 19.753 21.9631 18.4693C22 18.2361 22 17.9574 22 17.4V15.1765C22 15.079 21.921 15 21.8235 15C20.2641 15 19 13.7359 19 12.1765V11.8235C19 10.2641 20.2641 9 21.8235 9C21.921 9 22 8.92099 22 8.82353V6.6C22 6.0426 22 5.76389 21.9631 5.5307C21.7598 4.24702 20.753 3.24025 19.4693 3.03693C19.2361 3 18.9574 3 18.4 3Z"
				fill="currentColor"
			/>
			<path
				d="M9 11V13M9 6V8M9 16V18M2 15.1765V17.4C2 17.9574 2 18.2361 2.03693 18.4693C2.24025 19.753 3.24702 20.7598 4.5307 20.9631C4.76389 21 5.0426 21 5.6 21H18.4C18.9574 21 19.2361 21 19.4693 20.9631C20.753 20.7598 21.7598 19.753 21.9631 18.4693C22 18.2361 22 17.9574 22 17.4V15.1765C22 15.079 21.921 15 21.8235 15V15C20.2641 15 19 13.7359 19 12.1765V11.8235C19 10.2641 20.2641 9 21.8235 9V9C21.921 9 22 8.92099 22 8.82353V6.6C22 6.0426 22 5.76389 21.9631 5.5307C21.7598 4.24702 20.753 3.24025 19.4693 3.03693C19.2361 3 18.9574 3 18.4 3H5.6C5.0426 3 4.76389 3 4.5307 3.03693C3.24702 3.24025 2.24025 4.24702 2.03693 5.5307C2 5.76389 2 6.0426 2 6.6V8.82353C2 8.92099 2.07901 9 2.17647 9V9C3.73586 9 5 10.2641 5 11.8235V12.1765C5 13.7359 3.73586 15 2.17647 15V15C2.07901 15 2 15.079 2 15.1765Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.25 2.25V6C8.25 6.41421 8.58579 6.75 9 6.75C9.41421 6.75 9.75 6.41421 9.75 6V2.25H16.35C18.5902 2.25 19.7103 2.25 20.566 2.68597C21.3186 3.06947 21.9305 3.68139 22.314 4.43404C22.75 5.28969 22.75 6.40979 22.75 8.65V9.41667C22.75 9.60076 22.6008 9.75 22.4167 9.75H22C20.7574 9.75 19.75 10.7574 19.75 12C19.75 13.2426 20.7574 14.25 22 14.25H22.4167C22.6008 14.25 22.75 14.3992 22.75 14.5833V15.35C22.75 17.5902 22.75 18.7103 22.314 19.566C21.9305 20.3186 21.3186 20.9305 20.566 21.314C19.7103 21.75 18.5902 21.75 16.35 21.75H9.75V18C9.75 17.5858 9.41421 17.25 9 17.25C8.58579 17.25 8.25 17.5858 8.25 18V21.75H7.65C5.40979 21.75 4.28969 21.75 3.43404 21.314C2.68139 20.9305 2.06947 20.3186 1.68597 19.566C1.25 18.7103 1.25 17.5902 1.25 15.35V14.5833C1.25 14.3992 1.39924 14.25 1.58333 14.25H2C3.24264 14.25 4.25 13.2426 4.25 12C4.25 10.7574 3.24264 9.75 2 9.75H1.58333C1.39924 9.75 1.25 9.60076 1.25 9.41667V8.65C1.25 6.40979 1.25 5.28969 1.68597 4.43404C2.06947 3.68139 2.68139 3.06947 3.43404 2.68597C4.28969 2.25 5.40979 2.25 7.65 2.25H8.25ZM9.75 10C9.75 9.58579 9.41421 9.25 9 9.25C8.58579 9.25 8.25 9.58579 8.25 10V14C8.25 14.4142 8.58579 14.75 9 14.75C9.41421 14.75 9.75 14.4142 9.75 14V10Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 3H9.5H5.6C5.0426 3 4.76389 3 4.5307 3.03693C3.24702 3.24025 2.24025 4.24702 2.03693 5.5307C2 5.76389 2 6.0426 2 6.6V8.82353C2 8.92099 2.07901 9 2.17647 9V9C3.73586 9 5 10.2641 5 11.8235V12.1765C5 13.7359 3.73586 15 2.17647 15V15C2.07901 15 2 15.079 2 15.1765V17.4C2 17.9574 2 18.2361 2.03693 18.4693C2.24025 19.753 3.24702 20.7598 4.5307 20.9631C4.76389 21 5.0426 21 5.6 21H18.4C18.9574 21 19.2361 21 19.4693 20.9631C20.753 20.7598 21.7598 19.753 21.9631 18.4693C22 18.2361 22 17.9574 22 17.4V15.1765C22 15.079 21.921 15 21.8235 15V15C20.2641 15 19 13.7359 19 12.1765V11.8235C19 10.2641 20.2641 9 21.8235 9V9C21.921 9 22 8.92099 22 8.82353V6.6C22 6.0426 22 5.76389 21.9631 5.5307C21.7598 4.24702 20.753 3.24025 19.4693 3.03693C19.2361 3 18.9574 3 18.4 3H14.5H14M9 11V13M9 6V8M9 16V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 11V13M9 6V8M9 16V18M2 15.1765V17.4C2 17.9574 2 18.2361 2.03693 18.4693C2.24025 19.753 3.24702 20.7598 4.5307 20.9631C4.76389 21 5.0426 21 5.6 21H18.4C18.9574 21 19.2361 21 19.4693 20.9631C20.753 20.7598 21.7598 19.753 21.9631 18.4693C22 18.2361 22 17.9574 22 17.4V15.1765C22 15.079 21.921 15 21.8235 15V15C20.2641 15 19 13.7359 19 12.1765V11.8235C19 10.2641 20.2641 9 21.8235 9V9C21.921 9 22 8.92099 22 8.82353V6.6C22 6.0426 22 5.76389 21.9631 5.5307C21.7598 4.24702 20.753 3.24025 19.4693 3.03693C19.2361 3 18.9574 3 18.4 3H5.6C5.0426 3 4.76389 3 4.5307 3.03693C3.24702 3.24025 2.24025 4.24702 2.03693 5.5307C2 5.76389 2 6.0426 2 6.6V8.82353C2 8.92099 2.07901 9 2.17647 9V9C3.73586 9 5 10.2641 5 11.8235V12.1765C5 13.7359 3.73586 15 2.17647 15V15C2.07901 15 2 15.079 2 15.1765Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M22.75 15.35V14.5833C22.75 14.3992 22.6008 14.25 22.4167 14.25H22C20.7574 14.25 19.75 13.2426 19.75 12C19.75 10.7574 20.7574 9.75 22 9.75H22.4167C22.6008 9.75 22.75 9.60076 22.75 9.41667V8.65C22.75 6.40979 22.75 5.28969 22.314 4.43404C21.9305 3.68139 21.3186 3.06947 20.566 2.68597C19.7103 2.25 18.5902 2.25 16.35 2.25H9V21.75H16.35C18.5902 21.75 19.7103 21.75 20.566 21.314C21.3186 20.9305 21.9305 20.3186 22.314 19.566C22.75 18.7103 22.75 17.5902 22.75 15.35Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 8.65V9.41667C1.25 9.60076 1.39924 9.75 1.58333 9.75H2C3.24264 9.75 4.25 10.7574 4.25 12C4.25 13.2426 3.24264 14.25 2 14.25H1.58333C1.39924 14.25 1.25 14.3992 1.25 14.5833V15.35C1.25 17.5902 1.25 18.7103 1.68597 19.566C2.06947 20.3186 2.68139 20.9305 3.43404 21.314C4.28969 21.75 5.40979 21.75 7.65 21.75H9V2.25H7.65C5.40979 2.25 4.28969 2.25 3.43404 2.68597C2.68139 3.06947 2.06947 3.68139 1.68597 4.43404C1.25 5.28969 1.25 6.40979 1.25 8.65Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
